export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8265.2fa74d1a.jpg";